import React, { useState, useEffect, useContext, useRef } from "react";
import { Redirect, Link, useHistory } from "react-router-dom";
import Alert, { showLoading, toast } from "../../../component/Alert";
import SubClinic from "./SubClinic";
import { BlockLoading } from "../../../component/Loading";
// import ReactToPrint from 'react-to-print';
import useDataRequesting from "../../../hooks/useDataRequesting";
import useDataFetching from "../../../hooks/useDataFetching";
import context from "../../context";
import Patient from "../../models/patient.class";
// import PrintStruct from 'view/component/PrintStruct';
import apiService from "apiService";
import BlobPrint from "view/component/BlobPrint";

const ClinicPage = (props) => {
  const puskesmas = JSON.parse(localStorage.getItem("puskesmasProfile"));
  const [printData, setPrintData] = useState("");
  const [patientData, setPatientData] = useState("");
  const [selectedData, setSelectedData] = useState("");
  const [isPoliMrPrint, setIsPoliMrPrint] = useState(false);
  const [isPoliTracerPrint, setIsPoliTracerPrint] = useState(false);
  const [clinicData, setClinicData] = useState({});
  const [subClinicData, setSubClinicData] = useState([]);

  const [selectedJadwal, setselectedJadwal] = useState(null);
  // const [selectedDokter, setselectedDokter] = useState(null);

  const [isSubClinicShow, setIsSubClinicShow] = useState(false);
  const { results, error, loading } = useDataFetching({
    // url: `/apm/clinics/read/${puskesmas.code}/2/0`,
    url: `/apm/clinics/apm/${puskesmas.code}/2/0`,
    method: "get",
  });
  const {
    results: resultsPost,
    loading: loadingPost,
    error: errorPost,
    setRequest,
  } = useDataRequesting();

  const history = useHistory();
  const patientContext = useContext(context);
  // const printRef1 = useRef();
  // const printRef2 = useRef();
  // const printRef3 = useRef();
  // let printTriggerRef1 = "";
  // let printTriggerRef2 = "";
  // let printTriggerRef3 = "";
  const getFirstJadwal = (data, id = null) => {
    let schedule =
      data.clinic.schedule.length > 0 ? data.clinic.schedule[0] : null;
    if (id && schedule) {
      return schedule.id;
    }
    return schedule;
  };
  const register = (data) => {
    if (data.clinic.child.length) {
      setSubClinicData(data);
      setClinicData(data.clinic);
    } else {
      // console.log(data);
      showLoading("Sedang Di Proses");
      setSelectedData(data);
      setClinicData(data.clinic);
    }
  };

  const nextPrint = () => {
    if (selectedData.print_mr && !isPoliMrPrint) setIsPoliMrPrint(true);
    else if (selectedData.print_tracer && !isPoliTracerPrint)
      setIsPoliTracerPrint(true);
    else history.push("/apm");
  };

  const pcare = async () => {
    if (resultsPost.data.visit.payment_type_id !== 1) {
      const bridgingResult = await apiService.post(
        `/pcare/pendaftaran/${resultsPost.data.visit.id}`
      );
    }
  };
  useEffect(() => {
    const { clinic = { child: [] } } = subClinicData;
    if (clinic.child.length) setIsSubClinicShow(true);
  }, [subClinicData]);

  useEffect(() => {
    if (selectedData) {
      const patient = new Patient({
        ...selectedData,
        bloodId: patientContext.data.examination
          ? patientContext.data.examination.blood_type_id
          : 0,
        previous_clinic_id: 0,
        paramedic_id: null,
      });
      setPatientData(patient);
    }
  }, [selectedData]);

  useEffect(() => {
    if (patientData)
      setRequest({
        url: "/registration/visit",
        method: "post",
        data: patientData,
      });
  }, [patientData]);

  useEffect(() => {
    if (resultsPost) {
      if (resultsPost.code === 200) {
        toast({ status: "success", text: "Data Berhasil" });
        // pcare();
        // Alert('error', resultsPost.status);
        // history.push('/apm/search');
        // setPrintData({
        //   ...patientData,
        //   ...resultsPost.data,
        //   clinicInfo: clinicData,
        // });
        printApi(resultsPost.data);
      } else {
        Alert("warning", resultsPost.status);
      }
    }
  }, [resultsPost]);

  const printApi = async (data) => {
    let vs = [];
    vs.push(data.visit.id);
    if (selectedData.print_mr) {
      vs.push(data.visit.id);
    }
    if (selectedData.print_tracer) {
      vs.push(data.visit.id);
    }
    const dt = BlobPrint(
      `/apm/queues/print?visit_id=${vs.toString()}&is_lab=false&multiple=true`
    );
    history.push("/apm/search");
    return dt;
  };

  // useEffect(() => {
  //   if (resultsPost) printTriggerRef1.handlePrint();
  // }, [printData]);

  // useEffect(() => {
  //   if (isPoliMrPrint) {
  //     printTriggerRef2.handlePrint();
  //   }
  // }, [isPoliMrPrint]);

  // useEffect(() => {
  //   if (isPoliTracerPrint) {
  //     printTriggerRef3.handlePrint();
  //   }
  // }, [isPoliTracerPrint]);

  if (!Object.values(patientContext.data).length)
    return <Redirect to="/apm/search" />;

  if (loading) {
    return <BlockLoading loading={loading} />;
  }

  const { data: datas = [] } = results;
  return (
    <div className="container-fluid mt--2">
      <div className="row mb-5">
        <div className="col offset-10">
          <Link to="/apm/search">
            <button
              type="button"
              className="btn btn-warning btn-icon float-right"
            >
              <span className="btn-inner--icon">
                <i className="fas fa-arrow-left"></i>
              </span>
              <span className="btn-inner--text">KEMBALI</span>
            </button>
          </Link>
        </div>
      </div>
      <div className="row">
        <div className="col d-flex flex-wrap justify-content-center">
          {datas.length > 0 ? (
            datas.map((data, i) => {
              return (
                <div key={i} className="card mx-3" style={{ width: "300px" }}>
                  <div
                    className="card-body text-center"
                    onClick={() =>
                      register({
                        ...patientContext.data,
                        ...data,
                        patient_id: patientContext.data.patient_id,
                        jadwal: selectedJadwal
                          ? selectedJadwal.id
                            ? selectedJadwal.poli == data.clinic_id
                              ? selectedJadwal
                              : getFirstJadwal(data)
                            : getFirstJadwal(data)
                          : getFirstJadwal(data),
                        paramedic_schedule_code: selectedJadwal
                          ? selectedJadwal.id
                            ? selectedJadwal.poli == data.clinic_id
                              ? selectedJadwal.id
                              : getFirstJadwal(data, "id")
                            : getFirstJadwal(data, "id")
                          : getFirstJadwal(data, "id"),
                      })
                    }
                  >
                    <h3 className="card-title display-4">
                      {data.clinic.name.toUpperCase()}
                    </h3>
                    <img
                      src="../assets/img/icons/health/iconfinder_Artboard_1_3872548.svg"
                      alt=""
                      height="100px"
                    />
                    <div className="card-text">{data.note}</div>
                  </div>
                  <div className="card-footer text-center">
                    <select
                      className="form-control"
                      onChange={(e) =>
                        setselectedJadwal({
                          ...JSON.parse(e.target.value),
                          poli: data.clinic.id,
                        })
                      }
                    >
                      <option value={"null"}>pilih</option>
                      {data.clinic.schedule.map((a, k) => (
                        <option
                          value={JSON.stringify(a)}
                          selected={k == 0 ? true : false}
                        >
                          {`${a.namadokter} (${a.jampraktek})`}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="mt-9">
              <h1 className="display-2">Klinik Tidak tersedia...</h1>
            </div>
          )}
        </div>
        {/* <ReactToPrint
          ref={(ref) => {
            printTriggerRef1 = ref;
          }}
          trigger={() => <button className='d-none'></button>}
          onAfterPrint={() => nextPrint()}
          content={() => printRef2.current}
        />
        <ReactToPrint
          ref={(ref) => {
            printTriggerRef2 = ref;
          }}
          trigger={() => <button className='d-none'></button>}
          onAfterPrint={() => nextPrint()}
          content={() => printRef2.current}
        />
        <ReactToPrint
          ref={(ref) => {
            printTriggerRef3 = ref;
          }}
          trigger={() => <button className='d-none'></button>}
          onAfterPrint={() => nextPrint()}
          content={() => printRef3.current}
        /> */}
      </div>
      <SubClinic
        show={isSubClinicShow}
        data={subClinicData}
        modifyClinicInfo={setClinicData}
        setSelectedData={setSelectedData}
        setModalShow={setIsSubClinicShow}
      />
      {/* <div style={{ display: 'none' }}>
        <PrintStruct
          ref={printRef1}
          type='poli'
          data={printData}
          puskesmasProfile={puskesmas}
        />
        <PrintStruct
          ref={printRef2}
          type='poli_mr'
          data={printData}
          puskesmasProfile={puskesmas}
        />
        <PrintStruct
          ref={printRef3}
          type='poli_tracer'
          data={printData}
          puskesmasProfile={puskesmas}
        />
      </div> */}
    </div>
  );
};

export default ClinicPage;
